module.exports = __webpack_public_path__ + "media/images/product/p_g-25958135c59cfbfe4b226169a8aeb79a.png";